export type CompanyResponse = {
  _id: string;
  accountId: string;
  name: string;
  settings?: CompanySettings;
  outlets?: string[];
};

export type CompanySettings = {
  logo?: string;
  url?: string;
  defaultLanguage?: string;
  timeZone?: string;
  automaticallyPrintReceipt?: boolean;
  enablePaymentTerminalTipping?: string;
  dateFormat?: string;
};

export enum CompanyTypes {
  ORGANIZATION = 'organization',
  COMPANY = 'company',
  ROOT = 'root',
}
